export const changeCountryNameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_COUNTRY_NAME":
      return action.payload.countryName;
    default:
      return state;
  }
};
